import { Injectable } from '@angular/core';
import CryptoJS from 'crypto-js';

import { environment } from '../../enviroment/enviroment';

@Injectable({ providedIn: 'root' })
export class EncryptionService {
  private readonly secretKey = environment.ANGULAR_APP_SECRET_KEY;

  encrypt(value: string): string {
    try {
      return CryptoJS.AES.encrypt(value, this.secretKey).toString();
    } catch (e) {
      console.error('Encryption error', e);
      return value;
    }
  }

  decrypt(value: string | null): string | null {
    if (!value) {
      return null;
    }
    try {
      const BYTES = CryptoJS.AES.decrypt(value, this.secretKey);
      return BYTES.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      console.error('Decryption error', e);
      return null;
    }
  }

  encodeBase64(value: string): string {
    try {
      return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(value));
    } catch (e) {
      console.error('Base64 encode error', e);
      return value;
    }
  }

  decodeBase64(value: string | null): string | null {
    if (!value) {
      return null;
    }
    try {
      const WORDS = CryptoJS.enc.Base64.parse(value);
      return CryptoJS.enc.Utf8.stringify(WORDS);
    } catch (e) {
      console.error('Base64 decode error', e);
      return null;
    }
  }
}
